export default class GetConvocatoriasPersonalByPersonalId {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idPersonal) {
    try {
      const result = await this.#repository.getConvocatoriasPersonalByPersonalId(idPersonal)
      return result
    } catch (error) {
      console.error('Error al obtener las convocatorias del personal:', error)
      throw error
    }
  }
}
